export type ImgComponentProps = {
  w: number;
  h: number;
  x: number;
  y: number;
};

const setPrevImgUrl = (imgUrl: string, props: ImgComponentProps, isImageBlurred: boolean) => {
  const myImgEvent = new CustomEvent('animatedImageAction', {
    detail: {
      url: imgUrl,
      props: props,
      isImageBlurred,
    },
  });

  document.dispatchEvent(myImgEvent);
};

const setNextImgUrl = (url: string, props: ImgComponentProps) => {
  const myImgEvent = new CustomEvent('animatedImageActionNew', {
    detail: {
      url: url,
      props: props,
    },
  });

  document.dispatchEvent(myImgEvent);
};

function getContainedSize(img: HTMLImageElement): ImgComponentProps {
  const bounding = img.getBoundingClientRect(); // get this props instead of just .width and .height because image can be upscaled on hover

  const ratio = img.naturalWidth / img.naturalHeight;
  let width = bounding.height * ratio;
  let height = bounding.height;
  if (width > bounding.width) {
    width = bounding.width;
    height = bounding.width / ratio;
  }
  return {
    w: width,
    h: height,
    x: bounding.x + bounding.width / 2 - width / 2,
    y: bounding.y + bounding.height / 2 - height / 2,
  };
}

export const onClickImageHandler = (e: PointerEvent | any, isImageBlurred: boolean) => {
  const imgProps = getContainedSize(e.target);

  const prevImgSrc = e.target?.currentSrc;
  if (prevImgSrc) setPrevImgUrl(prevImgSrc, imgProps, isImageBlurred);
};

export const onImageOnloadHandler = (imgComponent: HTMLImageElement) => {
  const nextImgSrc = imgComponent.currentSrc;
  const imgData = imgComponent.getBoundingClientRect();

  const imgProps: ImgComponentProps = {
    x: imgData.x,
    y: imgData.top,
    w: imgData.width,
    h: imgData.height,
  };

  setNextImgUrl(nextImgSrc, imgProps);
};

export const seamlessImageNavigation = (e: PointerEvent | MouseEvent, target?: HTMLElement, isImageBlurred = false) => {
  if (e.metaKey || e.ctrlKey) return;

  const imageHandlerProps = target || e.target;

  onClickImageHandler({ target: imageHandlerProps }, isImageBlurred);
};
